function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from "react";
import styled, { css } from "styled-components";
import { transparentizedPrimaryColor, transparentizedPositiveColor, transparentizedNegativeColor } from "../../../helpers/transparentize";
const colors = {
  primary: transparentizedPrimaryColor,
  positive: transparentizedPositiveColor,
  negative: transparentizedNegativeColor
};
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1icwgfs-0"
})(["position:absolute;background-color:", ";color:transparent;opacity:0.5;", ""], ({
  color
}) => colors[color], ({
  active
}) => active && css(["opacity:1;"]));
Root.defaultProps = {
  color: "primary"
};
const Rect = /*#__PURE__*/memo(({
  rects,
  ...props
}) => rects.map(({
  left,
  top,
  width,
  height
}, i) => /*#__PURE__*/React.createElement(Root, _extends({
  key: i,
  style: {
    top: `${top * 100}%`,
    left: `${left * 100}%`,
    width: `${width * 100}%`,
    height: `${height * 100}%`
  }
}, props))));
Rect.defaultProps = {
  rects: []
};
export default Rect;
//# sourceMappingURL=Rect.js.map